import type { DetailedHTMLProps, HTMLAttributes } from 'react';

type DetailsProps = DetailedHTMLProps<HTMLAttributes<HTMLDetailsElement>, HTMLDetailsElement>;
type SummaryProps = DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>;

export const Details = ({ className = '', children, ...rest }: DetailsProps) => (
    <details
        className={`my-4 rounded-2xl border border-newui bg-white overflow-hidden font-figtree ${className}`}
        {...rest}
    >
        {children}
    </details>
);

export const Summary = ({ className = '', children, ...rest }: SummaryProps) => (
    <summary
        className={`px-4 py-2 bg-white cursor-pointer hover:bg-newui-lighter transition-colors text-newui-primary font-medium flex items-center gap-2 font-figtree ${className}`}
        {...rest}
    >
        {children}
    </summary>
);